import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { LoginStoreEffects } from '@app/root-store/login-store/effects';

import { DocumentService } from '@app/shared/services';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';

import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
@AutoUnsubscribe()
@Component({
  selector: 'contact',
  templateUrl: './contact.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DiscoveryContactComponent implements OnInit, OnDestroy {
  securityStateObject;
  subscription: Subscription = new Subscription();
  @Output() moveNextPreviousEvent = new EventEmitter<any>();
  currentuserId;
  loadOnce = true;
  @Input() data;
  constructor(
    private documentService: DocumentService,
    private loginService: LoginStoreEffects,
    private store: Store,
    private cd: ChangeDetectorRef
  ) {}
  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  parentFun(event) {
    this.moveNextPreviousEvent.next({ status: event.status, id: this.data.id });
  }
  ngOnInit(): void {
    this.subscription.add(
      this.loginService.loginObject.subscribe((state) => {
        if (state?.data) {
          this.currentuserId = state.data.id;
          if (this.loadOnce) {
            this.loadOnce = false;
          }
        }
      })
    );
  }
}
